import { httpRequest } from '@calendly/http-tools'

import { stripeClientSecretFetched, stripeClientSecretPending } from '../../../actions/payment'

export const fetchClientSecret = (eventTypeUuid) => async (dispatch, getState) => {
  const state = getState()
  const { status } = state.scheduling.stripeClientSecret

  if (status !== 'ready' || !eventTypeUuid) return

  dispatch(stripeClientSecretPending())

  const [ok, res] = await httpRequest({
    url: '/api/booking/stripe_payment_intents',
    method: 'POST',
    data: { event_type_uuid: eventTypeUuid }
  })

  if (ok) {
    dispatch(stripeClientSecretFetched(res.resource.client_secret))
  } else {
    dispatch({ type: 'SET_STRIPE_CLIENT_SECRET', payload: { status: 'ready', value: null } }) // Reset to default
  }
}
